export const previewScriptContainerId = 'reveni-tryon-preview-script'
export const widgetContainerId = 'reveni-try-on-widget'
export const buttonContainerId = 'reveni-try-on-button-container'
export const overlayId = 'reveni-try-on-overlay'
